document.addEventListener('DOMContentLoaded', function () {
  initRevelado();
  initGalerias();
  initFormulariosProducto();
  initContadores();
  initBarraFija();
  initFaqAcordeon();
  initBundles();
  initComparadores();
  initReservaCarrito();
});

/* ---------- Reveals al hacer scroll ---------- */
function initRevelado() {
  var elementos = document.querySelectorAll('.mt-reveal');
  if (!elementos.length) return;

  if (!('IntersectionObserver' in window)) {
    elementos.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  elementos.forEach(function (el) { observer.observe(el); });
}

/* ---------- Galería del producto: miniatura -> imagen principal ---------- */
function initGalerias() {
  document.querySelectorAll('.mt-galeria').forEach(function (galeria) {
    var principal = galeria.querySelector('.mt-galeria__principal img');
    if (!principal) return;

    galeria.querySelectorAll('.mt-galeria__miniatura').forEach(function (miniatura) {
      miniatura.addEventListener('click', function () {
        var full = miniatura.getAttribute('data-full');
        var alt = miniatura.getAttribute('data-alt') || '';
        if (!full) return;
        principal.setAttribute('src', full);
        principal.setAttribute('alt', alt);
        galeria.querySelectorAll('.mt-galeria__miniatura').forEach(function (m) {
          m.classList.remove('mt-galeria__miniatura--activa');
        });
        miniatura.classList.add('mt-galeria__miniatura--activa');
      });
    });
  });
}

/* ---------- Selector de variantes del producto ---------- */
function initFormulariosProducto() {
  document.querySelectorAll('.mt-producto').forEach(function (raiz) {
    var datosEl = raiz.querySelector('[data-mt-variantes]');
    if (!datosEl) return;

    var variantes;
    try {
      variantes = JSON.parse(datosEl.textContent);
    } catch (e) {
      return;
    }

    var inputId = raiz.querySelector('input[name="id"]');
    var precioEl = raiz.querySelector('[data-mt-precio]');
    var precioCompareEl = raiz.querySelector('[data-mt-precio-comparado]');
    var badgeAhorroEl = raiz.querySelector('[data-mt-badge-ahorro]');
    var botonComprar = raiz.querySelector('[data-mt-boton-comprar]');
    var selectores = raiz.querySelectorAll('[data-mt-opcion]');

    function formatearDinero(centavos) {
      var valor = (centavos / 100).toFixed(2).replace('.', ',');
      return valor + ' ' + (raiz.getAttribute('data-moneda') || '€');
    }

    function opcionesSeleccionadas() {
      var seleccion = [];
      selectores.forEach(function (grupo) {
        var activo = grupo.querySelector('input:checked, select');
        if (!activo) return;
        var valor = activo.tagName === 'SELECT' ? activo.value : activo.value;
        seleccion.push(valor);
      });
      return seleccion;
    }

    function encontrarVariante() {
      var seleccion = opcionesSeleccionadas();
      return variantes.find(function (v) {
        return v.opciones.length === seleccion.length && v.opciones.every(function (op, i) {
          return op === seleccion[i];
        });
      });
    }

    function actualizar() {
      if (!selectores.length) return;
      var variante = encontrarVariante();
      if (!variante) return;

      if (inputId) inputId.value = variante.id;
      if (precioEl) precioEl.textContent = formatearDinero(variante.precio);

      if (precioCompareEl) {
        if (variante.precioComparado && variante.precioComparado > variante.precio) {
          precioCompareEl.textContent = formatearDinero(variante.precioComparado);
          precioCompareEl.style.display = '';
        } else {
          precioCompareEl.style.display = 'none';
        }
      }

      if (badgeAhorroEl) {
        if (variante.precioComparado && variante.precioComparado > variante.precio) {
          var pct = Math.round(((variante.precioComparado - variante.precio) / variante.precioComparado) * 100);
          badgeAhorroEl.textContent = '-' + pct + '%';
          badgeAhorroEl.style.display = '';
        } else {
          badgeAhorroEl.style.display = 'none';
        }
      }

      if (botonComprar) {
        if (variante.disponible) {
          botonComprar.disabled = false;
          botonComprar.textContent = botonComprar.getAttribute('data-texto-disponible') || botonComprar.textContent;
        } else {
          botonComprar.disabled = true;
          botonComprar.textContent = botonComprar.getAttribute('data-texto-agotado') || 'Agotado';
        }
      }
    }

    selectores.forEach(function (grupo) {
      grupo.addEventListener('change', actualizar);
    });

    actualizar();
  });
}

/* ---------- Cifras animadas (count-up) ---------- */
function initContadores() {
  var contadores = document.querySelectorAll('[data-mt-contador]');
  if (!contadores.length) return;

  if (!('IntersectionObserver' in window)) {
    contadores.forEach(animarContador);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animarContador(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.4 }
  );

  contadores.forEach(function (el) { observer.observe(el); });
}

/* ---------- Barra fija de compra en móvil ---------- */
function initBarraFija() {
  var ancla = document.querySelector('[data-mt-ancla-compra]');
  var barra = document.querySelector('[data-mt-barra-fija]');
  if (!ancla || !barra) return;

  var boton = barra.querySelector('[data-mt-barra-fija-boton]');
  if (boton) {
    boton.addEventListener('click', function () {
      var formulario = ancla.closest('.mt-producto__form') || document.querySelector('.mt-producto__form');
      if (formulario && formulario.requestSubmit) formulario.requestSubmit();
    });
  }

  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var pasadoPorArriba = entry.boundingClientRect.top < 0;
        if (!entry.isIntersecting && pasadoPorArriba) {
          barra.classList.add('mt-barra-fija--visible');
        } else {
          barra.classList.remove('mt-barra-fija--visible');
        }
      });
    },
    { threshold: 0 }
  );

  observer.observe(ancla);
}

/* ---------- FAQ: cierra las demás preguntas al abrir una (acordeón) ---------- */
function initFaqAcordeon() {
  document.querySelectorAll('.mt-faq').forEach(function (faq) {
    var detalles = faq.querySelectorAll('details');
    detalles.forEach(function (detalle) {
      detalle.addEventListener('toggle', function () {
        if (!detalle.open) return;
        detalles.forEach(function (otro) {
          if (otro !== detalle) otro.open = false;
        });
      });
    });
  });
}

/* ---------- Bundles: elegir un pack fija la cantidad del formulario real ---------- */
function initBundles() {
  document.querySelectorAll('[data-mt-bundles]').forEach(function (seccion) {
    var packs = seccion.querySelectorAll('[data-mt-pack]');
    if (!packs.length) return;

    var cantidadInput = document.querySelector('[data-mt-cantidad]');

    function seleccionar(pack) {
      packs.forEach(function (p) { p.classList.remove('mt-bundle--seleccionado'); });
      pack.classList.add('mt-bundle--seleccionado');
      if (cantidadInput) {
        cantidadInput.value = pack.getAttribute('data-mt-pack-cantidad');
        cantidadInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    packs.forEach(function (pack) {
      pack.addEventListener('click', function () { seleccionar(pack); });
    });

    var botonComprar = seccion.querySelector('[data-mt-pack-comprar]');
    if (botonComprar) {
      botonComprar.addEventListener('click', function () {
        var seleccionado = seccion.querySelector('.mt-bundle--seleccionado') || packs[0];
        seleccionar(seleccionado);
        var formulario = document.querySelector('.mt-producto__form');
        if (formulario && formulario.requestSubmit) formulario.requestSubmit();
      });
    }
  });
}

function animarContador(el) {
  var destino = parseFloat(el.getAttribute('data-mt-contador'));
  if (isNaN(destino)) return;
  var duracion = 1400;
  var inicio = null;
  var sufijo = el.getAttribute('data-mt-sufijo') || '';

  function paso(timestamp) {
    if (!inicio) inicio = timestamp;
    var progreso = Math.min((timestamp - inicio) / duracion, 1);
    var valor = Math.floor(progreso * destino);
    el.textContent = valor + sufijo;
    if (progreso < 1) requestAnimationFrame(paso);
    else el.textContent = destino + sufijo;
  }

  requestAnimationFrame(paso);
}

/* ---------- Comparador apagada / encendida: la luz crece con la barra ---------- */
function initComparadores() {
  document.querySelectorAll('[data-mt-comparador]').forEach(function (caja) {
    var rango = caja.querySelector('[data-mt-rango]');
    if (!rango) return;
    var tocado = false;
    function pintar(v) { caja.style.setProperty('--luz', (v / 100).toFixed(3)); }
    rango.addEventListener('input', function () { tocado = true; pintar(rango.value); });
    pintar(rango.value);

    // Al entrar en pantalla la lámpara se enciende sola una vez, para enseñar el efecto
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      var inicio = null, dur = 2600;
      function paso(t) {
        if (tocado) return;
        if (!inicio) inicio = t;
        var p = Math.min((t - inicio) / dur, 1);
        var e = p < .5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        rango.value = Math.round(e * 100);
        pintar(e * 100);
        if (p < 1) requestAnimationFrame(paso); else caja.classList.add('mt-anima');
      }
      setTimeout(function () { requestAnimationFrame(paso); }, 500);
    }, { threshold: 0.6 });
    observer.observe(caja);
  });
}

/* ---------- Carrito: cuenta atrás de reserva (10 minutos, por sesión del navegador) ---------- */
function initReservaCarrito() {
  var caja = document.querySelector('[data-mt-reserva-carrito]');
  if (!caja) return;
  var elTiempo = caja.querySelector('[data-mt-reserva-tiempo]');
  if (!elTiempo) return;

  var DURACION_MS = 10 * 60 * 1000;
  var CLAVE = 'mt_reserva_carrito_expira';

  function leerOCrearExpiracion() {
    var guardada = null;
    try { guardada = sessionStorage.getItem(CLAVE); } catch (e) {}
    var expira = guardada ? parseInt(guardada, 10) : NaN;
    if (!expira || isNaN(expira) || expira <= Date.now()) {
      expira = Date.now() + DURACION_MS;
      try { sessionStorage.setItem(CLAVE, String(expira)); } catch (e) {}
    }
    return expira;
  }

  var expira = leerOCrearExpiracion();

  function pintar() {
    var restante = expira - Date.now();
    if (restante <= 0) {
      expira = Date.now() + DURACION_MS;
      try { sessionStorage.setItem(CLAVE, String(expira)); } catch (e) {}
      restante = DURACION_MS;
    }
    var minutos = Math.floor(restante / 60000);
    var segundos = Math.floor((restante % 60000) / 1000);
    elTiempo.textContent = minutos + ':' + (segundos < 10 ? '0' : '') + segundos;
  }

  pintar();
  setInterval(pintar, 1000);
}
